import type { FunctionComponent } from 'react';
import { Fragment } from 'react';

export const FormattedName: FunctionComponent<{
    readonly defaultText: string;
    readonly reviewer: { readonly firstName: string; readonly lastName: string } | null | undefined;
}> = ({ defaultText, reviewer }) => {
    if (reviewer === undefined || reviewer === null) {
        return <Fragment>{defaultText}</Fragment>;
    }

    return <Fragment>{`${reviewer.firstName} ${reviewer.lastName}`}</Fragment>;
};
